module.exports = __webpack_public_path__ + "static/simplifies-your-life-21ecf2ec2e65013b3d967558af854f44.png";